<h1>Вход</h1>
<small class="auth-hint" *ngIf="registrationAvailable">Нет учетной записи? <a routerLink="/registration">Первичная регистрация</a></small>

<form (submit)="onFormSubmitClick()">
  <div class="form-floating mb-3">
    <input type="text" class="form-control" id="username" name="username" [(ngModel)]="username" required>
    <label for="username">Логин</label>
  </div>

  <div class="form-floating mb-3">
    <input type="password" class="form-control" id="password" name="password" [(ngModel)]="password" required>
    <label for="password">Пароль</label>
  </div>

  <div class="mb-4">
    <div class="invalid-feedback d-block" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
  </div>

  <button class="btn btn-primary w-100" type="submit">Войти</button>
</form>
